<pr-modal clazz="pr-modal-confirm" [display]="display">
  <div class="pr-modal-confirm-header d-flex align-items-center gap-s mbl">
    @if (icon) {
      <pr-icon [name]="icon"></pr-icon>
    }
    <h4 class="man bold">{{ title }}</h4>
  </div>
  <div class="question mbxl"><ng-content></ng-content></div>
  @if (comment) {
    <p>{{ comment }}</p>
  }
  <div
    [class]="
      optionnalLabel && showCancel
        ? 'three-buttons'
        : showConfirm
          ? 'two-buttons'
          : 'one-button'
    "
  >
    @if (showCancel) {
      <pr-button
        [title]="labelCancel"
        size="lg"
        [label]="labelCancel"
        (onClick)="close()"
      ></pr-button>
    }
    @if (optionnalLabel) {
      <pr-button
        [display]="displayOptionnal"
        [title]="optionnalLabel"
        size="lg"
        [label]="optionnalLabel"
        (onClick)="optionnalConfirm()"
      ></pr-button>
    }
    @if (showConfirm) {
      <pr-button
        [disabled]="disabledSubmit"
        [display]="display"
        size="lg"
        [title]="labelCancel"
        [label]="labelConfirm"
        (onClick)="confirm($event)"
      ></pr-button>
    }
  </div>
</pr-modal>
